import axios from '../request/http.js'

class Staff {
  /* 部门与成员列表查询 */
  static getDepartmentPeopleList(id, queryStr) {
    const url = `/zzd/api/back/user/list/member?id=${id}&queryStr=${queryStr}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取某四级部门的成员 */
  static getPeopleList(id, queryStr, currentPage) {
    const url = `/zzd/api/back/user/list/members?id=${id}&queryStr=${queryStr}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取详情 */
  static getDetailsList(id, deptId) {
    const url = `/zzd/api/back/user/detail?id=${id}&deptId=${deptId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取变更部门数据 */
  static getChangeDepartmentList(id, queryStr, keyword) {
    const url = `/zzd/api/back/dept/list?id=${id}&queryStr=${queryStr}&keyword=${keyword}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 某模块管理员的管理范围内的组织信息 */
  static getModuleManagerDepartmentList(keyword) {
    const url = `/zzd/api/back/dept/list/sub/admin/data/range?keyword=${keyword}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存变更部门 */
  static postSelectDepartmentList(data) {
    const url = `/zzd/api/back/user/update/dept`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑成员 */
  static postModStaffList(data) {
    const url = `/zzd/api/back/user/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取职级 */
  static getRankList() {
    const url = `/zzd/api/back/user/list/rank`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取政治面貌 */
  static getPoliticalFaceList() {
    const url = `/zzd/api/back/user/list/politicalFace`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取人员编制 */
  static getStaffingList() {
    const url = `/zzd/api/back/user/list/staffing`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 一级管理员获取待分配人员 */
  static getAssignPeopleList(id, name, currentPage) {
    const url = `/zzd/api/back/user/list/free/member?id=${id}&name=${name}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 二级管理员获取待分配人员 */
  static getTwoLeverAssignPeopleList(id, name, currentPage) {
    const url = `/zzd/api/back/user/list/free/member/by/team?id=${id}&name=${name}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存待分配人员 */
  static postSaveAssignPeople(data) {
    const url = `/zzd/api/back/user/add/dept`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 发起借调 */
  static postSecond(data) {
    const url = `/zzd/api/back/user/initiate/on-Loan/identity`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 解除借调 */
  static postReleaseSecondment(data) {
    const url = `/zzd/api/back/user/remove/on-Loan/identity`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 借调确认列表 */
  static postSecondList() {
    const url = `/zzd/api/back/user/on-Loan/list`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 接受借调人员 */
  static postAcceptsSecondStaff(id) {
    const url = `/zzd/api/back/user/receive/on-Loan/identity/${id}`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 接受借调人员 */
  static postRejectSecondStaff(id) {
    const url = `/zzd/api/back/user/reject/on-Loan/identity/${id}`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 移至待分配 */
  static postMoveToPendingAssignment(data) {
    const url = `/zzd/api/back/user/move/to/free`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Staff;